import React from "react"
// import configureStore from "./src/store/configureStore"
// import configureReadPlanStore from "./src/store/useReadPlan/configureReadPlanStore"
import "./static/global.css"
import WrapLayout from "./src/components/Layout/WrapLayout"
import initGA from './src/apis/googleAnalytics'

const isBrowser = typeof window !== "undefined"

const setupLocalStorage = () => {
  if (!localStorage.getItem("currentLanguage")) {
    localStorage.setItem("currentLanguage", "ENG")
  }
  if (!localStorage.getItem("currentVersion")) {
    localStorage.setItem("currentVersion", "NLT")
  }
  if (!localStorage.getItem("currentSegment")) {
    localStorage.setItem("currentSegment", "S001")
  }
}

const setupInstallPromptBridge = () => {
  if (!isBrowser) return
  if (window.__svbInstallPromptBootstrapDone) return
  window.__svbInstallPromptBootstrapDone = true

  const updateAvailability = value => {
    window.__svbInstallPromptAvailable = value
    window.dispatchEvent(new CustomEvent("svb-install-availability-changed"))
  }

  window.addEventListener("beforeinstallprompt", event => {
    event.preventDefault()
    window.__svbDeferredInstallPrompt = event
    updateAvailability(true)
    console.log("[PWAInstallBridge] beforeinstallprompt captured early")
  })

  window.addEventListener("appinstalled", () => {
    window.__svbDeferredInstallPrompt = null
    updateAvailability(false)
    console.log("[PWAInstallBridge] appinstalled")
  })
}

export const wrapPageElement = ({ element, props }) => {
  return <WrapLayout {...props}>{element}</WrapLayout>
}
export const wrapRootElement = ({ element, props }) => {
  if (isBrowser) {
    setupLocalStorage()
    setupInstallPromptBridge()
  }
  return <div {...props}>{element}</div>
}

export function registerServiceWorker() {
  return true
}
